import { GLYPHS } from "./glyphs/index";

export type Glyph = keyof typeof GLYPHS;
export default GLYPHS;
